import { useState } from 'react';
import { MyOnlyWeekView } from './MyOnlyWeekView.jsx';
import { WeekGridView } from './WeekGridView.jsx';
import { WeekByEmployeeView } from './WeekByEmployeeView.jsx';

export function MyScheduleView({ location, locations, user, isManager }) {
  // Round 32: My is the default view (own shifts) — most common need is
  // "what am I working today/this week", not "show me the manager grid".
  // R44: Gantt dropped — staff confused, managers can use the Build
  // Schedule timeline instead.
  const [mode, setMode] = useState('my');
  // CJ 2026-08-10. "My" and "Grid" described the layout; these describe what
  // you get. The ids stay put — they are what the toggle state is keyed on.
  const modes = [
    { id: 'my',    label: 'My Schedule' },
    { id: 'grid',  label: 'All Shifts' },
    // CJ 2026-10-06: the week by person, across every store. Managers and
    // owners — it puts every store's staff on one screen.
    ...(isManager ? [{ id: 'people', label: 'By Employee' }] : []),
  ];
  return (
    <div className="space-y-3">
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
        {modes.map((m) => (
          <button key={m.id} onClick={() => setMode(m.id)}
            style={{
              padding: '6px 12px', fontSize: 12, fontWeight: 600,
              background: mode === m.id ? 'var(--ink)' : '#fff',
              color: mode === m.id ? '#fff' : 'var(--text-primary)',
              border: `1px solid ${mode === m.id ? 'var(--ink)' : 'var(--rule)'}`,
              borderRadius: 6, cursor: 'pointer', fontFamily: 'inherit',
            }}>
            {m.label}
          </button>
        ))}
      </div>
      {mode === 'my'   && <MyOnlyWeekView location={location} user={user} />}
      {mode === 'grid' && <WeekGridView location={location} isManager={isManager} />}
      {mode === 'people' && <WeekByEmployeeView locations={locations} />}
    </div>
  );
}
